/**
 * 校验并返回可交给 React Router 的当前站点内路径。
 *
 * 后端已经执行同类守卫；前端再次校验，避免异常历史数据形成开放跳转。
 */
export function resolveSafeNotificationTarget(
  targetUrl: string | null | undefined,
  origin = window.location.origin,
): string | null {
  const normalized = targetUrl?.trim() ?? "";
  if (!normalized.startsWith("/") || normalized.startsWith("//") || normalized.includes("\\")) {
    return null;
  }

  let decoded = normalized;
  try {
    for (let index = 0; index < 3; index += 1) {
      const next = decodeURIComponent(decoded);
      if (next === decoded) break;
      decoded = next;
    }
  } catch {
    return null;
  }
  if (decoded.startsWith("//") || decoded.includes("\\")) return null;

  try {
    const resolved = new URL(decoded, origin);
    const expectedOrigin = new URL(origin).origin;
    const collapsedPath = resolved.pathname.replace(/\/{2,}/g, "/").toLowerCase();
    if (
      resolved.origin !== expectedOrigin ||
      collapsedPath === "/login" ||
      collapsedPath === "/auth/login"
    ) {
      return null;
    }
    return `${resolved.pathname}${resolved.search}${resolved.hash}`;
  } catch {
    return null;
  }
}

/** 将北京时间字符串格式化为紧凑的本地展示时间。 */
export function formatNotificationTime(value: string): string {
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return new Intl.DateTimeFormat("zh-CN", {
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(parsed);
}
